webpackJsonp([218847402008549],{

/***/ 398:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var icon1 = "https://www.winpeforum.com/assets/elements/Ankita.png";
	var icon2 = "https://www.winpeforum.com/assets/elements/Jahnvi.jpg";
	var icon3 = "https://www.winpeforum.com/assets/elements/NehaGupta.jpeg";
	var icon4 = "https://www.winpeforum.com/assets/elements/Pooja.jpeg";
	var icon5 = "https://www.winpeforum.com/assets/elements/Ria.jpeg";
	var icon6 = "https://www.winpeforum.com/assets/elements/Shruti.jpeg";
	var icon7 = "https://www.winpeforum.com/assets/elements/Shweta.jpeg";
	var icon8 = "https://www.winpeforum.com/assets/elements/Sneha.jpeg";
	var icon9 = "https://www.winpeforum.com/assets/elements/Stuti.jpg";
	var icon10 = "https://www.winpeforum.com/assets/elements/Sushma.jpeg";
	var icon11 = "https://www.winpeforum.com/assets/elements/Tushara.jfif";
	var icon12 = "https://www.winpeforum.com/assets/elements/Vaishnavi.jpeg";
	
	var mentConstant3 = [{
	    imgUrl: icon1,
	    desc: "Ankita is a VP at Fireside Ventures and leads investments in F&B and Nutrition space. At Fireside, Ankita works closely with portfolio companies in the FMCG space and leads ecosystem relationships and portfolio company strategy for tech enablers. Ankita enjoys working with founders and helping them unlock their vision. She previously invested in 8+ consumer tech companies (across EdTech, HealthTech, RealEstate Tech) during her stint at Venture Highway. Before embarking on the investing journey, Ankita spent 5+ years in consulting helping clients in consumer tech, telecom, real-estate and healthcare space at Bain & Co and Strategy& (Erstwhile Booz&Co.). Ankita graduated from IIT Delhi, majoring in Computer Science and did her MBA from IIM-Ahmedabad.\n\n         ",
	    name: "Ankita Balotia",
	    company: "Fireside",
	    post: "Vice President",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/ankita-balotia1792/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, {
	    imgUrl: icon2,
	    desc: "Jahnvi is a Vice President at Lighthouse, where she oversees the finance and operations functions. Prior to joining Lighthouse, she has worked for close to 15 years at PwC, KPMG and BMR Advisors. Her focus area was fund structuring & set-up, transaction structuring & support, tax / regulatory advisory and compliance for private equity, venture capital and public markets funds. Jahnvi also has experience in tax and regulatory matters pertaining to financial services sector. Jahnvi earned a Bachelor of Commerce from the University of Mumbai and is a Chartered Accountant.\n         ",
	    name: "Jahnvi Parekhi",
	    company: "Lighthouse Advisors",
	    post: "Vice President",
	    newpost: "Deputy, CFO",
	    newcompany: "Lighthouse Funds",
	    linkedIn: "https://www.linkedin.com/in/jahnvi-parekh-javeri-3b18ab25/?originalSubdomain=in"
	}, {
	    imgUrl: icon3,
	    desc: "Approx 14 years of total experience. Started the career with investment banking (post MBA from XLRI Jamshedpur in 2011). Moved to investments in infrastructure at Isquared Capital. Now a VP in NIIF investments team\n\n         ",
	    name: "Neha Gupta",
	    company: "National Investment and Infrastructure Fund",
	    post: "Vice President",
	    newpost: "Principal",
	    newcompany: "National Investment and Infrastructure Fund",
	    linkedIn: "https://www.linkedin.com/in/neha-gupta-14175513/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, {
	    imgUrl: icon4,
	    desc: "Pooja has been working in the VC industry for 6 plus years now. She started her career working with a startup, Housing.com and was the finance business partner to the product, design and technology teams. She then moved to the other side of the table in investing and was one of the first hires at Equanimity. At Equanimity, she looks at the entire investment life cycle, right from sourcing to in-depth business diligence to leading document negotiations to working closing with the founders post funding till the exit. Some of the deals led by her include Renee Cosmetics, Insurance Samadhan, SamosaSingh, Thinkly, DrStore and PrepBytes. She is a Chartered Accountant and she did her internship with PwC in their financial services group.\n\n         ",
	    name: "Pooja Parmar",
	    company: "Equanimity Investments",
	    post: "Senior Associate",
	    newpost: "Principal",
	    newcompany: "Equanimity Investments",
	    linkedIn: "https://www.linkedin.com/in/pooja-parmar-69712789/?originalSubdomain=in"
	}, {
	    imgUrl: icon5,
	    desc: "Ria Shroff Desai leads the People and Culture function at Blume Ventures. As part of Blume's leadership team,Ria works to create an ecosystem of growth, support, innovation and challenge to find & enable the best and brightest to solve India's most pressing problems. She has significant international experience living and working in multicultural environments in India, the United States and the Dominican Republic. Ria has worked extensively with CXO teams and helped them to align strategic goals to actionable objectives, while focusing on building strong, sustainable and smart teams. Her strengths lie in deep stakeholder engagement, setting the foundational blocks for a high-ownership culture and working as a strategic partner to the business to leverage human capital.\n\n         ",
	    name: "Ria Shroff Desai",
	    company: "Lead - People & Culture | Associate Vice Presidentuti",
	    post: "Blume Ventures",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/riashroff/?originalSubdomain=in"
	}, {
	    imgUrl: icon6,
	    desc: "Shruti is an investment professional at CDPQ India focusing on infrastructure investments in South Asia, with over 7 years of experience in private equity and investment banking. Before joining CDPQ, she worked at Kotak Investment Banking for 3 years working on Infrastructure, Industrials and IT deals. Shruti holds an MBA degree from Indian institute of Management, Lucknow and a Bachelors of Commerce from Delhi University. She is a scuba enthusiast, with just 1 dive short of a diving certificate. She also enjoys reading fiction and baking in her free time.\n\n        \n         ",
	    name: "Shruti Goyal",
	    company: "CDPQ India Pvt Ltd",
	    post: "Senior Associate",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/shruti-goyal-8794b566/?originalSubdomain=in"
	}, {
	    imgUrl: icon7,
	    desc: "Shweta Laddha is presently working with Multiples Alternate Asset Management as Vice President and Head – Compliance and Secretarial. She has more than 14 years of diversified work experience across BFSI (investment banking, compliance, corporate secretarial, legal) and have worked with all financial sectoral regulators in India. At Multiples, in addition to managing all regulatory/ non-regulatory compliances (including AIF, PIT and AML Regulations) of Multiples PE Funds and group entities, her role is to strengthen governance of portfolio companies and providing compliance-oriented solutions to businesses. Her prior stints include working with NIIF Infrastructure Finance Limited as Company Secretary and Compliance Officer, Aditya Birla Capital Group where she has led Compliance, Legal and Secretarial division of Fintech arm of Aditya Birla Capital along with working extensively with other ABC group companies and ECM division of BOB Capital Markets. She is a Company Secretary, LLB (General) and PGDM (finance) by qualification.",
	    name: "Shweta Laddha",
	    company: "Multiples Alternate Asset Management Private Limited ",
	    post: "Vice President",
	    newpost: "Head- Compliance & Secretarial",
	    newcompany: "Multiples Alternate Asset Management Private Limited",
	    linkedIn: "https://www.linkedin.com/in/shweta-laddha/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, {
	    imgUrl: icon8,
	    desc: "I am a first-generation lawyer, who started my career with AZB & Partners in 2013. I studied Masters of Law at the University of Pennsylvania Law School In 2017. I returned to India post my Master and continue working at AZB & Partners. I have been recently promoted to be a part of the elite partnership at AZB. Over the years at AZB, I have advised various private equity clients on high-value M&A deals. I have been the Co-President for the UPenn Alumni Club in Mumbai and organized several events including fire-side chats with Mrs. Zia Mody and Mrs. Arundhati Bhattacharya. I also assist NGO firms with pro-bono work and recently worked with Destiny Reflection to obtain an FCRA registration which could enable them to procure foreign funds for their noble work.\n\n         ",
	    name: "Sneha Nagvekar",
	    company: "AZB & Partners",
	    post: "Partner",
	    newpost: "Partner",
	    newcompany: "Veritas Legal",
	    linkedIn: "https://www.linkedin.com/in/sneha-nagvekar-32193118/?originalSubdomain=in"
	}, {
	    imgUrl: icon9,
	    desc: "Stuti Bhartia is an early growth stage investor at 360 ONE Asset (Formerly IIFL Asset Management) and focuses on investments across tech companies in India, with over 7 years\u2019 experience in venture capital and investment banking. Prior to IIFL Asset, Stuti has worked in Goldman Sachs, Credit Suisse & Guild Capital focusing on consumer, tech, and healthcare sector. She earned her Master\u2019s in Business Administration from the Indian Institute of Management, Kozhikode and has a BTech in Computer Science Engineering.\n\n         ",
	    name: "Stuti Bhartia",
	    company: "360 ONE Asset (formerly IIFL Asset Management)",
	    post: "Vice President ",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/stutibhartia/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=in"
	}, {
	    imgUrl: icon10,
	    desc: "Sushma is a Partner at Aavishkaar Capital and brings with her over 15 years of deep expertise in early and early growth stage investing. Sushma has worked to identify, scale and exit large number of companies and has worked closely with several inclusive business entrepreneurs. She has been an active representative on the Boards of several companies like Arohan Microfinance, Utkarsh Microfinance, Rangsutra etc. She started off with an entrepreneurial venture in engineering services and moved on to roles in investments. She was part of the acquisition team at Starwood Capital where she evaluated diverse real estate assets. She has worked closely with many seed stage companies that have listed in the public markets. \n        Sushma has completed a strategic leadership program at the Harvard Business School. She is an engineering graduate from RVCE, Bangalore and has an MBA from the Indian School of Business, Hyderabad. Sushma loves solving problems and in her free time advises startups across sectors. She was recognized as \u201C40 UNDER 40\u201D Alternate investment professional in India and as one of the Top 100 Women in Finance-2020 in the \u201Cleading\u201D category. Sushma is an active participant in various Industry bodies including GPCA, IVCA and Impact Investors Council.\n         \n        \n         ",
	    name: "Sushma Kaushik",
	    company: "Aavishkaar Capital",
	    post: "Partner",
	    newpost: "Head- Innovation Fund",
	    newcompany: "Larsen & Toubro",
	    linkedIn: "https://www.linkedin.com/in/sushmakaushik/?originalSubdomain=in"
	}, {
	    imgUrl: icon11,
	    desc: "Tushara Garg, VP, Investment team, True North: Tushara is a Vice President with the Investment team at True North, focusing on Technology (IT Services and SaaS) and Financial Services (Traditional lending and insurance) verticals. Key work highlights:<br/> 1) Led TN’s investments in Accion Labs and iLink Multitech,<br/> 2) Managing multiple exits in FS (Fedfina, Infinity, HFFC) and<br/> 3) Working alongside portfolio companies to deliver the underwriting case<br/><br/> Prior to joining True North, Tushara spent around 4 years with Tata Sons Investment Office, contributing significantly to numerous investments, including notable ones such as Air India and Big Basket. This tenure provided invaluable insights and expertise in navigating complex investment landscapes. Before transitioning to the buy-side, Tushara held junior roles as an investment banker at Deutsche and Standard Chartered. A native of Indore, Tushara holds a CA and an MBA from IIM Kozhikode. Beyond the realm of investing, Tushara aims to live a well-rounded and balanced life with an aim to bolster the mind-body connection and her day involves yoga, meditation, reading and quality time with loved ones.",
	    name: "Tushara Garg",
	    company: "True North",
	    post: "Vice President",
	    newpost: "-",
	    newcompany: "-",
	    linkedIn: "https://www.linkedin.com/in/tushara-garg-584b4ab0/?originalSubdomain=in"
	}, {
	    imgUrl: icon12,
	    desc: "Currently, working in British International Investment (earlier known as CDC) as an Investment Director covering Technology and Telecom for Asia. I am a Chartered Accountant with c.12 years of experience in private equity and investment banking. Avid reader and fond of Indian classical arts esp. dancing and music.\n         ",
	    name: "Vaishnavi Suryanarayanan",
	    company: "British International Investment Plc",
	    post: "Investment Director - Technology and Telecom",
	    newpost: "Investment Director - South Asia",
	    newcompany: "British International Investment Plc",
	    linkedIn: "https://www.linkedin.com/in/vaishnavi-s-59524b37/"
	},,];
	
	exports.default = mentConstant3;
	module.exports = exports["default"];

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(571);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentConstant = __webpack_require__(398);
	
	var _mentConstant2 = _interopRequireDefault(_mentConstant);
	
	var _Media = __webpack_require__(38);
	
	var _MediaRight = __webpack_require__(55);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'head_section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'item_name' },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'cross pull-right' },
	        _react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'item__desc force-overflow' },
	        _react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var Index = exports.Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(args) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	
	    return _this;
	  }
	
	  Index.prototype.render = function render() {
	    var location = this.props.location;
	    var isShow = this.state.isShow;
	
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentees: Cohort of 2023', description: 'A group of highly talented young women on their path to continued success.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mentees-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Mentees ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('span', null),
	              ' Cohort IV'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section_intro_text' },
	            'A group of highly talented young women on their path to continued success.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _mentConstant2.default.map(function (item, i) {
	              if (i == 12) return _react2.default.createElement(
	                'div',
	                { className: '  col-sm-6 col-md-3 col-md-offset-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner' },
	                    _react2.default.createElement('img', { className: 'imagess', src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Previous Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Current Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                )
	              );else return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner' },
	                    _react2.default.createElement('img', { className: 'imagess', src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Previous Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Current Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.newcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-iv-index-js-b921642ecb3712870dfb.js